export default __webpack_public_path__ + "static/media/trustero_logo_white.86af0e83.svg";